export default __webpack_public_path__ + "src/images/loading_font-8eeb2a.xml";